export const t = {
  bg: "#f4f6fa",
  white: "#ffffff",
  border: "#e4e8f0",
  borderLight: "#edf0f6",
  text: "#0f1420",
  t2: "#5a6480",
  t3: "#a0aac0",
  green: "#01BBA7",
  greenDark: "#019385",
  greenLight: "#e3f8f5",
  greenText: "#016e62",
  amber: "#f59d0d",
  amberLight: "#fff8e8",
  amberText: "#7a4d00",
  red: "#e03e3e",
  redLight: "#fff0f0",
  redText: "#8b1a1a",
  blue: "#3b7cf4",
  blueLight: "#edf2ff",
  blueText: "#1a3fa0",
  purple: "#7c3aed",
  purpleLight: "#f3f0ff",
  r: "16px",
  rs: "10px",
  rxs: "6px",
  sh: "0 1px 3px rgba(15,20,40,.05),0 4px 20px rgba(15,20,40,.07)",
  shHover: "0 10px 36px rgba(15,20,40,.14)",
};

// Shared macro color convention — matches the client v2 nutrition donut exactly
// (MACRO_COLORS = {carbs: t.green, proteins: t.blue, fats: t.amber}).
// Use the SOLID hues (not the *Text variants) so bars/chips match the donut slices.
export const macro = {
  calories: { text: t.text, soft: t.bg, label: "קלוריות", short: "קל׳" },
  protein:  { text: t.blue, soft: t.blueLight, label: "חלבון", short: "ח׳" },
  carbs:    { text: t.green, soft: t.greenLight, label: "פחמימות", short: "פ׳" },
  fats:     { text: t.amber, soft: t.amberLight, label: "שומנים", short: "ש׳" },
  // fiber is NOT part of the donut, but it sits next to carbs everywhere it is shown —
  // it needs its own hue or the two read as the same number twice.
  fiber:    { text: t.purple, soft: t.purpleLight, label: "סיבים", short: "ס׳" },
};
